import { Component, Inject, Input, ViewEncapsulation } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { ModalResponseCodes } from '@src/suite/common/components/modal/modal.service';

export interface AlertData {
    title: string;
    content: any;
    ok: string;
}

@Component({
    selector: 'st-alert-modal',
    templateUrl: './alert.html',
    styleUrls: ['../modal/modal.scss'],
    host: {
        class: 'st-alert',
    },
    encapsulation: ViewEncapsulation.None,
})
export class AlertModalComponent {
    @Input() public title: string = 'Title';
    @Input() public content: any = 'Content';

    @Input() public ok: string = 'Ok';

    constructor(
        public dialogRef: MatDialogRef<AlertModalComponent>,
        @Inject(MAT_DIALOG_DATA) public data: AlertData
    ) {
        this.title = data.title;
        this.content = data.content;
        this.ok = data.ok;
    }

    onOKClick(): void {
        this.dialogRef.close(ModalResponseCodes.OK);
    }
}
